import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6ekrb4hxre: FaireBrandEntity = {
  token: "b_6ekrb4hxre",
  type: "brand",
  name: "Mustard Seed",
  avatarUrl:
    "https://cdn.faire.com/fastly/0a0dbf1f724f76cc823830d05db6e0a1dd2d6652f118431b87a74c30555bd12a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7d552cbb4f14ada99c0191b6ad2f1ff3aa090383d17807233af1306673073607.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0a0dbf1f724f76cc823830d05db6e0a1dd2d6652f118431b87a74c30555bd12a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7d552cbb4f14ada99c0191b6ad2f1ff3aa090383d17807233af1306673073607.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.7,
  reviewCount: 345,
  isInsider: true,
  description:
    "Founded in Los Angeles in 2008, Mustard Seed began with a mission to design and produce a unique blend of eye catching and trendy fashion for young women.\nMustard Seed can be found in boutiques and specialty chains all across the United States.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:41.268Z",
    importedBy: "entity-db-cli",
  },
};
